import RestService from './RestService';
import IExperience from 'interfaces/IExperience';

export default class ExperienceService extends RestService<IExperience> {
  constructor() {
    super('experiences');
  }
}
